/**
 * Model/provider configuration comparison section.
 *
 * @module config-comparison/ModelConfigDiffSection
 */
import React from 'react';
import { Text } from '@chatsdet/ui';
import type { EnvironmentSnapshot } from '@chatsdet/types';
import { DiffTable } from './DiffTable';
import { diffSnapshots, toRecord } from './diff-utils';

interface ModelConfigDiffSectionProps {
  configA: EnvironmentSnapshot['modelConfig'] | undefined;
  configB: EnvironmentSnapshot['modelConfig'] | undefined;
  labelA: string;
  labelB: string;
}

export function ModelConfigDiffSection({ configA, configB, labelA, labelB }: ModelConfigDiffSectionProps) {
  const rows = React.useMemo(
    () => diffSnapshots(toRecord(configA), toRecord(configB)),
    [configA, configB],
  );

  return (
    <div>
      <Text weight="medium" className="mb-2">Model Configuration</Text>
      <DiffTable rows={rows} labelA={labelA} labelB={labelB} />
    </div>
  );
}
